import {
  JsonInput,
  JsonInputType,
} from 'components/UI/JsonForm/JsonInputRenderer/types';
import { IApplicationFormStep } from 'features/ApplicationForm/types';

type InitialValues = {
  [K in JsonInputType]: any;
};
const initialValuesAsPerInputType: InitialValues = {
  input: '',
  select: '',
  date: '',
  radio: false,
  checkbox: false,
  file: '',
  'checkbox-group': [],
  'radio-group': '',
  textarea: '',
  masked: '',
  info: '',
  empty: '',
  'info-with-inputs': '',
};
export const generateInitialValuesForInputs = (inputs: JsonInput[]) => {
  return inputs.reduce((acc, input) => {
    const {
      props,
      isArray,
      inputs: nestedInputs,
      arrayName = '',
      type,
    } = input;
    const { name = '' } = props;
    if (isArray && nestedInputs) {
      acc = {
        ...acc,
        [arrayName]: [
          {
            arrayId: `${new Date().valueOf()}`,
            ...convertFlatToNestedJson(
              generateInitialValuesForInputs(nestedInputs)
            ),
          },
        ],
      };
    } else if (type === 'info' || type === 'info-with-inputs') {
      console.log('');
    } else {
      acc = {
        ...acc,
        [name]: input.defaultValue
          ? input.defaultValue
          : initialValuesAsPerInputType[type],
        ...convertFlatToNestedJson(
          generateInitialValuesForInputs(nestedInputs || [])
        ),
      };
    }
    return acc;
  }, {});
};

const convertFlatToNestedJson = (json: Record<string, any>) => {
  let result: Record<string, any> = {};
  Object.keys(json).forEach((key, index) => {
    let parts = key.split('.');
    let last = parts.pop() || '';
    let node: Record<string, any> = result;
    parts.forEach(function (key) {
      node = node[key] = node[key] || {};
    });
    if (last) {
      node[last] = json[key];
    }
  });
  return result;
};

export const generateInitialValues = (steps: IApplicationFormStep[]) => {
  const flatInitialValues = steps.reduce((acc, currentStep) => {
    const currentSectionInitialValues = currentStep.sections.reduce(
      (sectionAccumulator, currentSection) => {
        const inputsInitialValues = generateInitialValuesForInputs(
          currentSection.inputs
        );
        sectionAccumulator = { ...sectionAccumulator, ...inputsInitialValues };
        return sectionAccumulator;
      },
      {}
    );
    acc = { ...acc, ...currentSectionInitialValues };
    return acc;
  }, {});
  return convertFlatToNestedJson(flatInitialValues);
};
